
export default class FingerPrintDeviceStorage {

    /**
     * Returns localStorage token
     * @param {string} num a number 
     */
    static getId()
    {
       return localStorage.getItem("usbVendorId");
    }

    /**
     * Save localStorage id
     * @param {string} id 
     */
    static setId(id)
    {   
        localStorage.setItem("usbVendorId", id);
    }

    /**
     * Delete localStorage id
     */
    static removeId()
    {
        localStorage.removeItem("usbVendorId");
    }
    
}
